import { Controller } from "@hotwired/stimulus"

// Speichert Highlight und Position sofort per PATCH (ohne Speichern-Button)
export default class extends Controller {
  static values = {
    toggleHighlightUrl: String,
    updateUrl: String,
  }

  async toggleHighlight(event) {
    const url = this.toggleHighlightUrlValue
    if (!url) return
    const checkbox = event.target
    checkbox.disabled = true
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "Accept": "text/vnd.turbo-stream.html, text/html",
        },
        credentials: "same-origin",
      })
      if (response.ok) {
        const html = await response.text()
        if (html.includes("turbo-stream")) {
          Turbo.renderStreamMessage(html)
        }
      } else {
        checkbox.checked = !checkbox.checked
      }
    } catch (e) {
      console.error("Highlight-Toggle fehlgeschlagen:", e)
      checkbox.checked = !checkbox.checked
    } finally {
      checkbox.disabled = false
    }
  }

  async savePosition(event) {
    const url = this.updateUrlValue
    if (!url) return
    const position = parseInt(event.target.value, 10)
    if (isNaN(position) || position < 1) return
    try {
      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
          "Content-Type": "application/x-www-form-urlencoded",
          "Accept": "text/vnd.turbo-stream.html, text/html",
        },
        credentials: "same-origin",
        body: new URLSearchParams({ position }),
      })
      if (response.ok) {
        const html = await response.text()
        if (html.includes("turbo-stream")) {
          Turbo.renderStreamMessage(html)
        }
      }
    } catch (e) {
      console.error("Position speichern fehlgeschlagen:", e)
    }
  }
}
